import { FETCH_HINTS } from './types';
import { getValidators } from '../services/chatService';

export const fetchHints = () => async (dispatch) => {
  try {
    const { data: { results } } = await getValidators();
    dispatch({ type: FETCH_HINTS, payload: results });
  } catch (e) {
    dispatch({ type: FETCH_HINTS, payload: {} });
  }
};

export default fetchHints;
